var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-layout"},[_c('Header'),_c('main',{staticClass:"main"},[_c('router-view')],1),_c('Footer',{attrs:{"colorHome":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }